export default __webpack_public_path__ + "static/media/META.c5cbf8c5.png";